// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-6"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 20V13M6 13H2M6 13H18M2 13V20M2 13V4L11.4444 12.5M18 13V20M18 13H22M22 13V20M22 13V4L12.5556 12.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge6Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-6',
    ref,
    icon: element,
  },
));

Bridge6Icon.displayName = 'Bridge6Icon';

export default Bridge6Icon;
